import EditNewsletterContainer from "../containers/EditNewsletterContainer";

const EditNewsletterPage = () => {
  return (
    <EditNewsletterContainer />
  );
};

export default EditNewsletterPage;
